<template>

	<div class="d-flex flex-column flex-grow-1 overflow-hidden">

		<header class="topbar flex-shrink-0">

			<nav class="navbar navbar-expand-lg navbar-light bg-light">

				<a href="#" class="navbar-brand" @click.prevent="gotoPage('/')" v-if="!mobileAsideRightActive && !mobileAsideLeftActive">Theme Deploy</a>

				<ul class="navbar-nav mr-3" v-if="page.id && !mobileAsideRightActive && !mobileAsideLeftActive" >
					<li class="nav-item">
						<a href="#" class="nav-link" @click.prevent="gotoPage('/project/'+page.project_id)">{{ project.name }}</a>
					</li>
					<li class="nav-item dropdown" @click.stop>
						<span class="nav-link dropdown-toggle" @click="togglePageDropdown">{{ page.name }}</span>
						<div class="dropdown-menu" :class="{show:pageDropdownOpened}">
							<a href="#" v-for="projectPage in project.pages" v-if="!projectPage.table_id" :key="projectPage.id" class="dropdown-item" @click.prevent="gotoPage('/project/'+page.project_id+'/'+projectPage.id)">{{projectPage.name}}</a>
							<div class="dropdown-divider"></div>
							<a href="#" v-for="projectPage in project.pages" v-if="projectPage.table_id" :key="projectPage.id" class="dropdown-item" @click.prevent="gotoPage('/project/'+page.project_id+'/'+projectPage.id)">{{projectPage.name}} <span class="badge badge-info">db</span></a>
							<div class="dropdown-divider"></div>
							<a class="dropdown-item" href="#" @click.prevent="newPage">{{ _lang('New page') }}</a>
						</div>
					</li>
				</ul>

				<div class="header-button-group" v-if="!mobileAsideRightActive && !mobileAsideLeftActive">

					<div class="btn-group btn-group-sm btn-group-toggle select-device mr-2" data-toggle="buttons">
						<label class="btn btn-secondary" :class="{active:previewDevice=='desktop'}">
							<input type="radio" v-model="previewDevice" value="desktop" autocomplete="off">
							<svg class="icosvg" viewBox="0 0 24 24">
								<path fill="currentColor" d="M21,14H3V4H21M21,2H3C1.89,2 1,2.89 1,4V16A2,2 0 0,0 3,18H10L8,21V22H16V21L14,18H21A2,2 0 0,0 23,16V4C23,2.89 22.1,2 21,2Z" />
							</svg>
						</label>
						<label class="btn btn-secondary" :class="{active:previewDevice=='mobile'}">
							<input type="radio" v-model="previewDevice" value="mobile" autocomplete="off">
							<svg class="icosvg" viewBox="0 0 24 24">
								<path fill="currentColor" d="M17.25,18H6.75V4H17.25M14,21H10V20H14M16,1H8A3,3 0 0,0 5,4V20A3,3 0 0,0 8,23H16A3,3 0 0,0 19,20V4A3,3 0 0,0 16,1Z" />
							</svg>
						</label>
					</div>

					<div class="info-saved">
						<button class="btn btn-sm btn-undo" :disabled="!canUndo" @click="undo()" :title="_lang('Undo')"><ico ico="undo" /></button>
						<button class="btn btn-sm btn-redo" :disabled="!canRedo" @click="redo()" :title="_lang('Redo')"><ico ico="redo" /></button>

						<button class="btn btn-sm btn-saving text-muted" v-show="!isSaving && !canSave" @click="savePage" :title="infoSaved">{{ _lang('Saved') }}<span v-show="infoSaved"> {{ _lang('on') }} {{infoSaved}}</span></button>
						<button class="btn btn-sm btn-saving btn-primary" v-show="!isSaving && canSave" @click="savePage">{{ _lang('Save changes') }}</button>
						<button class="btn btn-sm btn-saving" v-show="isSaving" disabled>{{ _lang('Saving') }} <ico ico="loading" style="display:inline-block;" /></button>

						<button class="btn btn-sm btn-secondary" :disabled="isSaving || canSave" @click="openPreview">{{ _lang('Preview') }}</button>
						<button class="btn btn-sm btn-primary" :disabled="isSaving || canSave" @click="openModalDomain">{{ _lang('Deploy') }}</button>
					</div>
				</div>

				<div class="header-button-group is-mobile">
					<button v-show="!mobileAsideRightActive && !mobileAsideLeftActive" class="btn btn-sm btn-primary" @click="mobileToggleAsideLeft">+ {{ _lang('Block menu') }}</button>
					<button v-show="!mobileAsideRightActive && mobileAsideLeftActive" class="btn btn-sm btn-secondary" @click="mobileCloseAsideLeft">&times; {{ _lang('Close menu') }}</button>

					<button v-show="mobileAsideRightActive" class="btn btn-sm btn-secondary ml-auto" @click="mobileCloseAsideRight">&times; {{ _lang('Close menu') }}</button>
				</div>

			</nav>
		</header>


		<div class="flex-fill d-flex overflow-hidden">
			<aside class="aside-left" :class="{active:mobileAsideLeftActive}">

				<div class="block-search">
					<ico ico="search" size="20" />
					<input type="text" v-model="blockSearchTerm" @keydown.esc="blockSearchTerm = ''" :placeholder="_lang('Search block')">
					<i v-if="blockSearchTerm.length>=2" @click="blockSearchTerm = ''">&times;</i>
				</div>

				<div v-if="blockSearchTerm.length>=2" class="separator"><span>{{ _lang('Search results') }}</span></div>
				<ul v-if="blockSearchTerm.length>=2 && filteredBlocks.length" class="category-blocks active" key="search">
					<li class="category-block" v-for="block in filteredBlocks" @mousedown="mouseDownComponent($event,block)" @click="mobileClick($event,block)" :title="block.name">
						<p class="block-header">{{ block.name }}</p>
						<figure><img v-if="block.image" :src="block.image"></figure>
					</li>
				</ul>
				<p v-if="blockSearchTerm.length>=2 && filteredBlocks.length==0" class="nofound">{{ _lang('No results for')}} "{{blockSearchTerm}}"</p>


				<ul class="categories" v-if="blockSearchTerm.length<2" @mouseleave="leaveMenuCategories" key="categories">

					<li class="separator"><span>{{ _lang('Elements') }}</span></li>
	 				<li class="category" @mouseenter="enterMenuCategory(elementsCategory.id)" :class="{active:categoryActive==elementsCategory.id}">
						<i v-html="elementsCategory.icon"></i>
						<span>{{ _lang('Elements','category') }}</span>
						<ul class="category-blocks" @mouseenter="enterMenuBlocks">
							<li class="category-block" v-for="block in elementsCategory.blocks" @mousedown="mouseDownComponent($event,block)" @click="mobileClick($event,block)" :title="block.name">
								<p class="block-header">{{ block.name }}</p>

								<figure><img v-if="block.image" :src="block.image"></figure>
							</li>
						</ul>
					</li>

					<li class="separator" v-if="myCategory.blocks.length"><span>{{ _lang('My Blocks') }}</span></li>
					<li class="category" v-if="myCategory.blocks.length"  @mouseenter="enterMenuCategory(myCategory.id)" :class="{active:categoryActive==myCategory.id}">
						<i v-html="myCategory.icon"></i>
						<span>{{ _lang('My Blocks','category') }}</span>
						<ul class="category-blocks" @mouseenter="enterMenuBlocks">
							<li class="category-block" v-for="block in myCategory.blocks" @mousedown="mouseDownComponent($event,block)" @click="mobileClick($event,block)" :title="block.name">
								<div class="block-header d-flex justify-content-between">
									<span>{{ block.name }}</span>
									<div class="dropdown ml-1 pr-2 pl-2" @mousedown.stop @mouseleave="closeDropdown">
										<span class="hand" @click.stop="openDropdown(block.id)">&hellip;</span>
										<div class="dropdown-content" v-if="isOpenDropdown(block.id)" v-on-clickaway="closeDropdown">
											<a class="btn btn-danger btn-small" @click="deleteMyBlock(block.id)" href="#">{{ _lang('Remove') }}</a>
										</div>
									</div>
								</div>
								<figure><img v-if="block.image" :src="block.image"></figure>
							</li>
						</ul>
					</li>

					<li class="separator"><span>{{ _lang('Blocks') }}</span></li>
					<li class="category" v-for="category in blockCategories" @mouseenter="enterMenuCategory(category.id)"  :class="{active:categoryActive==category.id}">
						<i v-html="category.icon"></i>
						<span>{{ _lang(category.name,'category') }}</span>
						<ul v-if="category.blocks" class="category-blocks" @mouseenter="enterMenuBlocks">
							<li class="category-block" v-for="block in category.blocks" @mousedown="mouseDownComponent($event,block)" @click="mobileClick($event,block)" :title="block.name">
								<p class="block-header">{{ block.name }}</p>
								<figure><img v-if="block.image" :src="block.image"></figure>
							</li>
						</ul>
					</li>

				</ul>



			</aside>

			<main>
				<div class="browser-wrapper">
					<div class="browser" :class="previewDevice" :style="browserStyles">
						<div v-if="blocks.length==0" class="browser-empty">{{ _lang('Drag blocks from the left menu') }}</div>
						<div class="browser-header">
							<div class="top-bar">
								<div class="circle"></div>
								<div class="circle"></div>
								<div class="circle"></div>
								<div class="tab"></div>
							</div>
							<div class="field"></div>
						</div>
						<div class="browser-window">
							<iframe class="preview" src="/iframe.html"></iframe>
						</div>
						<div class="browser-footer"></div>
					</div>
				</div>
			</main>

			<aside class="aside-right d-flex flex-column"  :class="{active:mobileAsideRightActive}">

				<ul class="nav nav-tabs flex-shrink-0">
					<li class="nav-item">
						<a class="nav-link" :class="{active:tabAsideRight=='page'}" href="#" @click.prevent="toggleTabAsideRight('page')">{{ _lang('Page') }}</a>
					</li>

					<li v-show="blocks.length>0" class="nav-item dropdown" @click.stop>
						<span class="nav-link dropdown-toggle" :class="{active:tabAsideRight=='block'}" @click="toggleBlockDropdown">{{ _lang('Block') }}</span>
						<div class="dropdown-menu" :class="{show:blockDropdownOpened}">
							<a
							v-for="block in orderedBlocks"
							:key="block.uid"
							class="dropdown-item"
							:class="{active:selectedComponent==block.uid}"
							href="#"
							@mouseenter="toggleHighlight(block.uid,1)"
							@mouseleave="toggleHighlight(block.uid,0)"
							@click.prevent="editComponent(block)"
							><span v-html="'·&nbsp;&nbsp;&nbsp;'.repeat(block.lvl)+block.name"></span>
							<svg v-if="block.effect" viewBox="0 0 24 24"><path fill="currentColor" d="M15,2A7,7 0 0,1 22,9C22,11.71 20.46,14.05 18.22,15.22C17.55,16.5 16.5,17.55 15.22,18.22C14.05,20.46 11.71,22 9,22A7,7 0 0,1 2,15C2,12.29 3.54,9.95 5.78,8.78C6.45,7.5 7.5,6.45 8.78,5.78C9.95,3.54 12.29,2 15,2M12,19A7,7 0 0,1 5,12C4.37,12.84 4,13.87 4,15A5,5 0 0,0 9,20C10.13,20 11.16,19.63 12,19M15,16A7,7 0 0,1 8,9H8C7.37,9.84 7,10.87 7,12A5,5 0 0,0 12,17C13.13,17 14.16,16.63 15,16V16M15,4C13.87,4 12.84,4.37 12,5V5A7,7 0 0,1 19,12H19C19.63,11.16 20,10.13 20,9A5,5 0 0,0 15,4M10,9A5,5 0 0,0 15,14C15.6,14 16.17,13.9 16.7,13.7C16.9,13.17 17,12.6 17,12A5,5 0 0,0 12,7C11.4,7 10.83,7.1 10.3,7.3C10.1,7.83 10,8.4 10,9Z" /></svg>
							</a>
						</div>
					</li>
				</ul>
				<div v-if="page.id" class="tab-content flex-fill overflow-auto" v-show="tabAsideRight=='page'">

					<div v-if="page.table_id" class="form-group">
						<label>{{ _lang('Post') }}</label>
						<select :value="selectedPost" @change="selectPost($event.target.value)" class="form-control">
							<option value="">-</option>
							<option v-for="post in posts" :value="post.id">{{post.name}}</option>
						</select>
					</div>

					<!-- text input with hint -->
					<div class="form-group">
						<label>{{ _lang('Title') }}</label>
						<input v-model="page.name" type="text" class="form-control" @input="edited=true">
					</div>
					<div class="form-group">
						<label>{{ _lang('Slug') }}</label>
						<input v-model="page.slug" :readonly="page.is_home || page.table_id" type="text" class="form-control" @input="edited=true">
					</div>
					<div class="form-group">
						<label>{{ _lang('SEO Description') }}</label>
						<textarea v-model="page.description" class="form-control" @input="edited=true"></textarea>
					</div>
					<div class="form-group">
						<label>{{ _lang('SEO Image') }}</label>
						<div class="custom-file">
							<input type="file" class="custom-file-input" @change="seoUpload($event)">
							<label class="custom-file-label">{{ _lang('Upload') }}</label>
						</div>
						<div v-if="page.image" class="d-flex">
							<img :src="page.image" class="img-thumbnail">
							<button class="close p-2" @click="page.image='',edited=true"><span>&times;</span></button>
						</div>
					</div>
					<div class="form-group">
						<label>{{ _lang('Header code') }}</label>
						<textarea class="form-control" v-model="page.meta.header" @input="edited=true"></textarea>
					</div>

				</div>
				<div class="tab-content flex-fill overflow-auto" v-show="tabAsideRight=='block'">


				<!--
				<div v-if="context">
				<div v-for="field in tableFields(context)">{dbfield.{{field.slug}}}</div>
				</div>
				<div v-else-if="page.table_id">
				<div v-for="field in postFields">{postfield.{{field.slug}}}</div>
				</div>
				-->

					<div v-if="data" v-for="(value,field) in data">

						<template v-if="model[field] && model[field].condition">
							<x-input v-show="saferEval(model[field].condition)" :config="model[field]" :name="field" :value="value" @change="xInputChange" :class="{disabled:model[field] && (model[field].postfield || model[field].dbfield)}" />
						</template>
						<template v-else>

							<x-input :config="model[field]" :name="field" :value="value" @change="xInputChange" :class="{disabled:model[field] && (model[field].postfield || model[field].dbfield)}" />

							<div v-if="model[field] && (['text','textarea','textarea-strip-tags','link','image','none'].includes(model[field].type) || model[field].type==undefined)">

								<div class="input-source" v-if="!context && page.table_id && selectedPost">
									<input type="checkbox" @change="setPostField(field,$event.target)" :checked="model[field].postfield!==undefined"> use page data
									<select @change="setPostField(field,$event.target)" :value="model[field].postfield">
										<option value=""></option>
										<option v-for="field in postFields" :value="field.slug">{{field.name}}</option>
									</select>
								</div>


								<div class="input-source" v-if="context">
									<input type="checkbox" @change="setDbField(field,$event.target)" :checked="model[field].dbfield!==undefined"> use collection data
									<select @change="setDbField(field,$event.target)" :value="model[field].dbfield">
										<option value=""></option>
										<option v-for="field in tableFields(context)" :value="field.slug">{{field.name}}</option>
									</select>
								</div>

							</div>


						</template>


					</div>

	        <div class="form-group">
            <label>{{ _lang('Transition') }}</label>
            <separator />
          </div>

					<div class="form-group">

						<select class="form-control" v-model="effect" @change="setEffect">
							<option value="" :selected="!effect">-</option>
							<optgroup :label="_lang('Recommended')">
								<option value="fadein">fade-in</option>
								<option value="fadein enter-left">fade-in enter-left</option>
								<option value="fadein enter-right">fade-in enter-right</option>
								<option value="fadein enter-top">fade-in enter-top</option>
								<option value="fadein enter-bottom">fade-in enter-bottom</option>
								<option value="fadein zoomin">fade-in zoom-in</option>
							</optgroup>

							<option value="enter-left">enter-left</option>
							<option value="enter-right">enter-right</option>
							<option value="enter-top">enter-top</option>
							<option value="enter-bottom">enter-bottom</option>
							<option value="zoomin">zoom-in</option>
							<option value="rotate-left">rotate-left</option>
							<option value="rotate-right">rotate-right</option>
							<option value="fadein zoomin rotate-left">fade-in zoom-in rotate-left</option>
							<option value="fadein zoomin rotate-right">fade-in zoom-in rotate-right</option>
							<option value="fadein zoomin enter-top">fade-in zoom-in enter-top</option>
							<option value="fadein zoomin enter-bottom">fade-in zoom-in enter-bottom</option>
							<option value="fadein rotate-left">fade-in rotate-left</option>
							<option value="fadein rotate-right">fade-in rotate-right</option>
							<option value="fadein enter-left rotate-left">fade-in enter-left rotate-left</option>
							<option value="fadein enter-right rotate-right">fade-in enter-right rotate-right</option>
						</select>
					</div>


					<div v-if="selectedComponent" class="block-actions">
						<button class="btn btn-sm btn-danger" @click="removeBlock(selectedComponent)" :title="_lang('Remove block')">
							<svg class="icosvg" viewBox="0 0 24 24">
								<path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
							</svg>
						</button>
						<button class="btn btn-sm btn-warning" @click="duplicateBlock(selectedComponent)" :title="_lang('Duplicate block')">
							<svg class="icosvg" viewBox="0 0 24 24">
								<path fill="currentColor" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
							</svg>
						</button>
						<button class="btn btn-sm btn-light" @click="editCode" :title="_lang('Edit code')">
							<svg class="icosvg" viewBox="0 0 24 24">
								<path fill="currentColor" d="M12.89,3L14.85,3.4L11.11,21L9.15,20.6L12.89,3M19.59,12L16,8.41V5.58L22.42,12L16,18.41V15.58L19.59,12M1.58,12L8,5.58V8.41L4.41,12L8,15.58V18.41L1.58,12Z" />
							</svg>
						</button>
					</div>
				</div>

			</aside>

		</div>


		<div class="modal modal-active" v-if="modalEdit">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<div class="modal-title">{{ _lang('Edit source code') }}</div>
						<span class="close" @click="modalEdit = false;">&times;</span>
					</div>
					<div class="modal-body">
						<div class="d-flex">
							<div label="HTML"><label>HTML</label><textarea class="block-template"></textarea></div>
							<div label="CSS"><label>CSS</label><textarea class="block-css"></textarea></div>
							<div label="Javascript"><label>Javascript</label><textarea class="block-js"></textarea></div>
						</div>
						<button class="btn btn-primary" @click.prevent="updateCode">{{ _lang('Update code') }}</button>
						<div>
							<button v-if="!modalSaveBlock" class="btn btn-primary mt-1" @click.prevent="modalSaveBlock=true">{{ _lang('Save in My Blocks') }}</button>
							<div v-if="modalSaveBlock" class="d-flex-inline p-1 form-inline">
								<span class="mr-3">{{ _lang('Save in My Blocks') }}</span>
								<select v-model="block.myblock_id" class="form-control mr-3" @change="block.name = $event.target.value?myCategory.blocks.find(i=>i.id==$event.target.value).name:''">
									<option value="" :selected="!block.myblock_id">{{ _lang('(New block)') }}</option>
									<optgroup label="Overwrite existing block">
										<option v-for="myblock in myCategory.blocks" :value="myblock.id">{{myblock.name}}</option>
									</optgroup>
								</select>
								<div class="form-group mr-3">
									<label class="mr-1">{{ _lang('Name') }}:</label>
									<input type="text" class="form-control" v-model="block.name">
								</div>
								<div class="form-group">
									<button class="btn btn-primary mr-1" @click.prevent="saveMyBlock()">{{ _lang('Save') }}</button>
									<span class="btn btn-light" @click="modalSaveBlock=false">{{ _lang('Cancel') }}</span>
								</div>
							</div>

						</div>
						<div v-if="isAdmin" class="d-flex-inline">

							<div class="p-1 form-inline">

								<div class="form-group mr-5">
									<select v-model="block.block_id" class="form-control">
										<optgroup label="Elements">
											<option v-for="block in elementsCategory.blocks" :value="block.id">{{block.name}}</option>
										</optgroup>
										<optgroup v-for="category in blockCategories" :label="category.name">
											<option v-for="block in category.blocks" :value="block.id">{{block.name}}</option>
										</optgroup>
										<optgroup label="(new block)">
											<option value="" :selected="!block.block_id">(new block)</option>
										</optgroup>

									</select>
								</div>

								<div class="form-group mr-5">
									<label class="mr-2">{{ _lang('Name') }}:</label>
									<input type="text" class="form-control" v-model="block.name">
								</div>

								<div class="form-group mr-5" v-if="block.block_id">
									<label class="mr-2">{{ _lang('Image') }}:</label>
									<div class="d-inline-flex mr-2">
										<span  class="ml-1 d-flex align-items-center">
											<input class="mr-1" type="text" v-model="screenshotSize">
											<label class="mr-1"><input type="checkbox" v-model="screenshotTrim"> trim</label>
											<button class="btn btn-light btn-sm" @click.prevent="autoThumbnail">Generate</button>
										</span>
									</div>
								</div>

								<div v-if="block.image" class="d-inline-flex" style="max-height:38px; max-width:200px;">
									<img :src="block.image" class="img-thumbnail">
									<button class="close p-2" @click="block.image=''"><span>&times;</span></button>
								</div>

								<div class="form-group mr-5">
									<label class="mr-2">Category</label>
									<select v-model="block.category_id" class="form-control">
										<option v-for="category in categories" :value="category.id">{{ category.name }}</option>
									</select>
								</div>

								<div class="form-group">
									<button class="btn btn-primary" @click.prevent="saveBlock()">Save block</button>
								</div>

							</div>

						</div>
					</div>
				</div>
			</div>
		</div>


		<project-publishing v-if="modalDomain" @update="getProject" @close="modalDomain = false" :project="project" />

	</div>


</template>

<style scoped>

.dropdown {
	position:relative;
}
.dropdown .dropdown-content{
	position:absolute;
	right:0;
	top:100%;
	background:#f8f9fa;
	box-shadow: 1px 1px 3px rgba(0,0,0,.5);
	padding:10px;
	border-radius:10px;
	z-index: 2;;
}


.soon { position:relative; opacity: .4; }
.soon:after {
	content:"soon";
	position: absolute;
	top:50%;
	right:0;
	padding:2px 5px;
	background:#333;
	color:#fff;
	font-weight: bold;
	font-size:.8em;
	transform: translate(0,-50%) rotate(-20deg);
}





.modal-active { display: block; }

.modal { background-color:rgba(0,0,0,.2);}
.modal textarea {width:100%; height:100%;}
.modal-dialog {
	max-width: 95vw;
}
.modal-body {     display: flex; flex-direction: column; }
.modal .d-flex { flex-grow: 1; justify-content: space-between; padding-bottom:5px;}
.modal .d-flex > div {
	flex: 1;  max-width: 33%;
	display: flex;
	flex-direction: column;
}
.modal .d-flex label {
	font-size: 10px;
}

.modal-content {
	height: calc(100vh - 3.5em);
}

.modal-my-block {

}

.input-source{}
.input-source [type=checkbox] {}
.input-source [type=checkbox]:not(:checked) + select { display:none;}
.input-source select {}



</style>


<script>

clearTimeout(window.saveTimer);
window.saveTimer = null;

import componentFunctions from '../mixin.components.js'
import axios from 'axios';
import Vue from 'vue'
import Xinput from '@/components/Xinput.vue';
import ProjectPublishing from '../components/ProjectPublishing.vue'
import { mixin as clickaway } from 'vue-clickaway';
import { Observable,Queue } from '@/helperStructures.js'

import Ico from '../components/Ico'
import Separator from '../components/inputs/Separator'

export default window.vmPage = {
	name: 'page',
	components:{
		'x-input':Xinput,
		ProjectPublishing,
		Ico,
		Separator
	},
	mixins:[componentFunctions, clickaway],
	props:['id','page_id'],
	data() {
		return {
			historyCursor:-1,
			history:[],
			historyDisabled:false,

			autoSave:true,
			edited:false,
			lastSavedTime:null,

			tabAsideRight:'page',
			pageDropdownOpened:false,
			blockDropdownOpened:false,
			publishDropdownOpened:false,
			modalEdit:false,
			modalSaveBlock:false,
			screenshotSize:'1280,600',
			screenshotTrim:true,
			modalDomain:false,

			dropdownActive:'',

			previewDevice:'desktop',
			page:{ meta:{header:''} },
			blocks:[],
			model:{},
			data:{},
			effect:'',
			context:null,
			selectedComponent:'',
			block:{},

			table:{},
			posts:[],
			selectedPost:'',

			mobileAsideLeftActive:false,
			mobileAsideRightActive:false,

			blockSearchTerm:'',

			categoryActive:null,
			timerDelay:null,
		}
	},

	watch:{
		edited:function(value){
			if(value) this.rescheduleSave();
		}

	},
	computed:{

		canUndo() {
			if(this.historyCursor == this.history.length-1 && this.edited) return true;
			return this.historyCursor>0;
		},
		canSave(){
			return this.edited;// || this.canRedo;
		},
		canRedo() {
			return this.historyCursor < this.history.length - 1;
		},

		isSaving(){
			return this.lastSavedTime == 'Saving';
		},
		infoSaved(){
			if(this.lastSavedTime == 'Saving') return "Saving...";
			if(this.lastSavedTime === null) return "";
			var date = this.lastSavedTime;
			var hh = ('0'+date.getHours()).substr(-2);
			var mm = ('0'+date.getMinutes()).substr(-2);
			var ss = ('0'+date.getSeconds()).substr(-2);
			return `${hh}:${mm}:${ss}`;
		},
		postFields(){
			if(!this.table.id) return [];
			var fields = [
			{name:"Date",slug:'created_at'},
			{name:"Name",slug:'name'},
			{name:"Permalink",slug:'permalink'},
			];
			fields.push(...this.table.fields);
			return fields;
		},
		browserStyles(){
			if(!isMobile()) return {};
			if(this.previewDevice=='desktop'){
				var scale = window.outerWidth/1280;
				return {
					transform:`scale(${scale})`,
					height:`calc(100% * 1/${scale})`,
				}
			}
		},
		tempurl(){
			if(!this.page.id) return ''
			var url =  process.env.VUE_APP_PROTOCOL+'://'+this.project.slug+'.'+process.env.VUE_APP_BASEURL+'/'+this.page.slug.replace(/\/$/,'');
			if(this.page.table_id && this.selectedPost){
				console.log('post slug',this.post.slug);
				url += '/'+this.post.slug;
			}
			return url;
		},
		orderedBlocks(){
			return this.blocks;
			/*.sort((a,b)=>{
				if (a.order==b.order) return a.id>b.id?1:-1;
				return a.order>b.order?1:-1;
			})*/
		},
		categories(){
			return this.$store.getters.allblocks.map(category=>{
				return {id:category.id,name:category.name};
			})
		},
		isAdmin(){
			return this.$store.getters.user.is_admin;
		},
		blockCategories(){
			return this.$store.getters.blocks.filter(cat => cat.name!='My Blocks' && cat.name!='Elements');
		},
		myCategory(){
			return this.$store.getters.blocks.find(cat => cat.name=='My Blocks');
		},
		elementsCategory(){
			return this.$store.getters.blocks.find(cat => cat.name=='Elements');
		},
		filteredBlocks(){
			if(this.blockSearchTerm.length<2) return [];

			var search = this.blockSearchTerm.trim().toLowerCase();

			var categories = JSON.parse(JSON.stringify(this.$store.getters.blocks));
			return categories.map(cat=>{
			// return this.$store.getters.blocks.map(cat=>{
				cat.blocks = cat.blocks.map(block=>{
					return (block.name + ' '+block.keywords).toLowerCase().includes(search)?block:null;
				}).filter(block=>block);
				return cat;
			}).filter(cat=>cat.blocks.length).reduce((acc,cat)=>{
				return [...acc,...cat.blocks];
			},[]);

		},
		project(){
			return this.$store.getters.project;
		},
		tables(){
			return this.$store.getters.tables;
		},
		post(){
			if(!this.selectedPost) return null;
			return this.posts.find(p=>p.id==this.selectedPost);
		}
	},
	mounted(){
		this.$store.dispatch('startLoading');

		document.addEventListener('click',e => {
			this.pageDropdownOpened = false;
			this.blockDropdownOpened = false;
			this.publishDropdownOpened = false;
		});

		PageGlobals()

		this.getPage().then(()=>{

			this.firstRenderIframe();
		}).finally(()=>{
			this.$store.dispatch('stopLoading');
		});


		if(this.$store.getters.blocks.length==0){
			this.$store.dispatch('getBlocks');
		}


		window.frameBus = {
			handler:null,
			mouseUpIframe:(uid)=>{
				frameBus.handler = null
				updateBlockList();
				this.editComponent({uid:uid});
			},
			updatedBlocks:(blocks)=>{
				console.log('updatedblocks');
				if(!blocks) return;

				blocks.forEach(block=>{
					var column = block.closest('[x-for$="in table"]');
					if(!column) return;
					var parentNode = column.parentNode;
					var grandParentNode = parentNode.closest('[x-vars]');
					var firstEl = parentNode.querySelector(':scope > [x-for$="in table"]');
					if(column!=firstEl){
						firstEl.innerHTML = column.innerHTML;
					}

					var context = null;
					var xVars = looseJsonParse(grandParentNode.getAttribute('x-vars'));
					if(xVars && xVars.table && xVars.table.dbtable) context = xVars.table.dbtable;
					if(context){
						renderCollection(context);
					} else {
						console.log('no context');
					}
				});
			},
			updateTree:()=>{
				updateBlockList();
				if(this.selectedComponent){
					//update container if any element dragged here
					this.editComponent({uid:this.selectedComponent});
				}
			},
			selectBlock:(uid)=>{
				var block = this.blocks.find((item) => item.uid == uid);
				if(block) this.editComponent(block);
			},
			iframeloaded:()=>{
				window.iframeDom = document.querySelector('iframe.preview').contentWindow;
				this.firstRenderIframe();
			}
		}

/*
		document.querySelector('iframe.preview').onload = () => {

		}
*/

		window.parseBlockSource = ()=>{

			//read data: insert on the page to be able to navigate through dom
			var dom = htmlToDom(blockObj.template);

			this.effect = dom.getAttribute('data-effect');
			blockObj.model = looseJsonParse(dom.getAttribute('x-vars')) || {};

				//blockObj.data = getDataFromTemplate(blockObj.template,blockObj.css);

				//better data reading

			blockObj.data = initializeElements(dom);
			var cssData = getDataFromCss(blockObj.css);
			for (var i in cssData){
				if(blockObj.data[i]!=undefined) continue;
				blockObj.data[i] = cssData[i];
			}

			//initilize values for all model fields
			var orderedData = {}
			for(var fieldName in blockObj.model) orderedData[fieldName] = null;
			for(var fieldName in blockObj.data) orderedData[fieldName] = blockObj.data[fieldName];
			blockObj.data = orderedData;

			//fetch data from sources
			for(var fieldName in blockObj.model) {
				if(blockObj.model[fieldName].source){

					console.log('parsing block source get source data ',fieldName);

					parseSourceData(blockObj,fieldName)

				}

			}

			refreshVueData();

			//updateIframe(position);
		}

		window.parseSourceData = (blockObj,fieldName) =>{

			getSourceData(blockObj.model[fieldName].source,this.page.project_id).then(data=>{
				//mapear os dados
				blockObj.sourceData = data;
				var resultData = [];
				for(var index in data){
					var row = data[index];
					var newRow = data[index];


					for(var to in blockObj.model[fieldName].sourceMap){
						var from = blockObj.model[fieldName].sourceMap[to];
						newRow[to] = row[from];
					}
					resultData.push(newRow);
				}
				console.log('resultaData',fieldName,resultData);
				setValues(fieldName,resultData)
			});

		}

		window.updateVueData = ()=>{
			this.data = blockObj.data;
			this.model = blockObj.model;
			this.block.template = blockObj.template;
			this.block.css = blockObj.css;
			this.block.js = blockObj.js;
			this.context = blockObj.context;
			this.effect = blockObj.effect;
			this.edited =true;

		}

		window.refreshVueData = ()=>{
			//this.edited =true;
			this.data = {};
			this.model = {};
			this.$nextTick(()=>{
				this.data = blockObj.data;
				this.model = blockObj.model;
				this.block.template = blockObj.template;
				this.block.css = blockObj.css;
				this.block.js = blockObj.js;
				this.context = blockObj.context;
			})
		}


		window.updateBlockList = (params)=>{

			var iframeBlocks = []
			var uids = []

			//var dom = iframeDom.body;
			var dom = iframeDom.rootElm

			walkLvl(dom,0,(el,lvl)=>{
				try{
					//svg and xml have object as class name
					var match = el.className.match(/block-(block\d+)/);
				} catch(e){
					var match = '';
				}
				if(match){
					var name = el.getAttribute('data-name') || match[1];
					if(uids.indexOf(match[1])>=0) return;
					uids.push(match[1]);
					iframeBlocks.push({
						uid:match[1],
						lvl:lvl,
						name:name,
						effect:el.firstChild && el.firstChild.hasAttribute && el.firstChild.hasAttribute('data-effect'),
					})
					lvl++;
				}
				return lvl;
			});

			this.blocks = iframeBlocks;
			if(!params || !params.firstUpdate) this.edited = true;

		},


		window.renderCollection = (dbtable)=>{
			console.log('renderCollection',dbtable);
			iframeDom.document.querySelectorAll('[x-vars*="dbtable"]').forEach(element=>{
				var xVars = looseJsonParse(element.getAttribute('x-vars')) || {};
				for(var field in xVars){
					if(xVars[field].dbtable==dbtable){

						var query = {dbtable:dbtable};
						if(this.page.table_id && this.selectedPost){
							query.table_id = this.page.table_id;
							query.post_id = this.selectedPost;
						}
						if(xVars[field].dborderfield) query.dborderfield = xVars[field].dborderfield;
						if(xVars[field].dblimit) query.dblimit = xVars[field].dblimit;
						if(xVars[field].dboffset) query.dboffset = xVars[field].dboffset;
						if(xVars[field].dbfilterfield) query.dbfilterfield = xVars[field].dbfilterfield;
						if(xVars[field].dbfiltervalue) query.dbfiltervalue = xVars[field].dbfiltervalue;
						if(xVars[field].dborderdir) query.dborderdir = xVars[field].dborderdir;
						if(xVars[field].dbfilterquery) query.dbfilterquery = encodeURIComponent(xVars[field].dbfilterquery);

						renderCollectionBlock(element,query);

					}
				}
			})
		}
		window.renderCollectionBlock = async (element,query)=>{
			console.log('renderCollectionBlock')

			var firstChild = element.querySelector(`[x-for$="in table"]`);
			if(firstChild.style.display == 'none') firstChild.style.display = '';
			var parentNode = firstChild.parentNode;
			var siblings = parentNode.querySelectorAll(`:scope > [x-for$="in table"]`);
			// console.log('v-for parent node',parentNode);

			//remove all, keep 1 only
			while(siblings.length>1) {
				parentNode.removeChild(siblings[1]);
				siblings = parentNode.querySelectorAll(`:scope > [x-for$="in table"]`);
			}

			var data = await this.$store.getters.tablePosts(query);

			if(!data) return;

			var childKey = firstChild.getAttribute('x-for').match(/^([a-z0-9-]+) in table/).pop();

			var i,f, currentEl;
			for(i=0;i<data.length;i++){
				if(i==0){
					currentEl = firstChild;
					// console.log('first node for parent node',parentNode);
				} else {
					var clone = firstChild.cloneNode(true);
					currentEl = parentNode.appendChild(clone);
					// console.log('post duplicated for parent node',parentNode);
				}

				for(f in data[i]){
					//console.log(childKey,f,data[i][f]);
					renderDataIntoFieldDb(currentEl,childKey,f,data[i][f]);
				}
			}

			if(data.length==0){
				firstChild.style.display = 'none';
			}

			queue.process('renderCollectionBlock');

			//observer.notify('renderCollectionBlock');
			//parseBlockSource();
			//updateIframe();

		}

		window.addEventListener('beforeUnload',(event)=>{
			console.log('beforeunload');
			if(this.edited || this.isSaving){
				event.returnValue = this._lang('Are you sure to leave with unsaved work?');
				//alert('are you sure to leave with unsaved work?');
			}
		});

	},
	beforeDestroy(){
		clearTimeout(window.saveTimer);
	},
	methods:{
		leaveMenuCategories(){
			clearTimeout(this.timerDelay);
			if(window.frameBus.handler){
				this.categoryActive = null;
				return;
			}
			this.timerDelay = setTimeout(()=>{
				this.categoryActive = null;
			},300);
		},
		enterMenuCategory(category_id){
			clearTimeout(this.timerDelay);
			if(!this.categoryActive) {
				this.categoryActive = category_id;
				return
			}
			this.timerDelay = setTimeout(()=>{
				this.categoryActive = category_id;
			},300);
		},
		enterMenuBlocks(){
			clearTimeout(this.timerDelay);
		},

		seoUpload(evt){
			this.$store.dispatch('startLoading');
			this.onFileInput(evt,(file,data)=>{
				this.$store.dispatch('stopLoading');
				this.page.image = data;
				this.edited=true;
			})
		},
		tableFields(context){
			var table = this.tables.find(table=>table.slug==context);
			if(!table) return [];

			var fields = [
				{name:"Date",slug:'created_at'},
				{name:"Name",slug:'name'},
			];
			if(table.meta.hasSingular){
				fields.push({name:"Permalink",slug:'permalink'});
			}
			fields.push(...table.fields);
			return fields;
/*
			if(this.page.table_id && this.selectedPost){
				context += `?table_id=${this.page.table_id}&post_id=${this.selectedPost}`;
			}
			var posts = this.$store.getters.tablePosts(context);
			if(!posts){
				this.$store.dispatch('queryTablePosts',context);
				return [];
			}
			return Object.keys(posts[0]);
*/
		},
		setPostField(field,domElement){
			var value;
			if(domElement.type=='checkbox'){
				if(domElement.checked){
					blockObj.model[field].postfield = '';
				} else {
					delete blockObj.model[field].postfield;
				}
			} else if (domElement.type=='select-one'){
				blockObj.model[field].postfield = domElement.value;
				setValue(field,this.post[domElement.value])
			}

			var dom = htmlToDom(blockObj.template);

			var output = modelToString(blockObj.model);
			dom.setAttribute('x-vars',output);

			blockObj.template = dom.outerHTML;

			updateIframe();
			parseBlockSource();

		},
		setDbField(field,domElement){
			console.log('setDbField',field)
			var value;
			if(domElement.type=='checkbox'){
				if(domElement.checked){
					blockObj.model[field].dbfield = '';
				} else {
					delete blockObj.model[field].dbfield;
				}
			} else if (domElement.type=='select-one'){
				blockObj.model[field].dbfield = domElement.value;
			}

			var dom = htmlToDom(blockObj.template);
			var output = modelToString(blockObj.model);
			dom.setAttribute('x-vars',output);

			blockObj.template = dom.outerHTML;

			updateIframe();

			queue.add('renderCollectionBlock',()=>{this.loadBlock(this.block)});
			renderCollection(blockObj.context);

		},
		selectPost(value){
			this.selectedPost = value;
			if(!iframeDom) return;
			var blocks = [];
			//register blocks by class name, so it can never break reference
			iframeDom.document.querySelectorAll('[x-vars*="postfield"]').forEach(el=>{
				blocks.push(el.parentNode.className);
			});
			blocks.forEach(blockClass=>{
				var block = iframeDom.document.querySelector('.'+blockClass);
				var xVars = looseJsonParse(block.firstChild.getAttribute('x-vars')) || {};
				for(var field in xVars){
					if(!xVars[field]['postfield']) continue;
					var postfield = xVars[field]['postfield'];
					var value = this.post[postfield];
					var newblockhtml = renderTemplateUpdate(block.innerHTML,field,value)
					block.innerHTML = newblockhtml;
				}
			});
			this.searchDBBlocks();
			//parseBlockSource();

		},
		gotoPage(url){
			//this.pageDropdownOpened = false;
			//clearTimeout(window.saveTimer);

			if((this.edited || this.isSaving) && !confirm(this._lang('You have unsaved changes. Are you sure you want to leave?'))){
				return;
			}
			clearTimeout(window.saveTimer);

			this.$router.push(url);
		},
		mobileToggleAsideLeft(){
			this.mobileAsideLeftActive = !this.mobileAsideLeftActive
		},
		mobileCloseAsideLeft(){
			this.mobileAsideLeftActive = false;
		},
		mobileClick(e,block){
			if(!isMobile()) return;
			this.mobileCloseAsideLeft();
			var timenow = new Date().getTime();
			var block_uid = 'block'+ timenow;
			block.uid = block_uid;
			block.template = iframeDom.redefineSubblocksUids(block.template,timenow);
			iframeDom.insertOrReplaceHtml(block_uid,block.template,block.name);
			iframeDom.dragElm = iframeDom.document.querySelector('div.block-'+block.uid);
			iframeDom.dropElement(null,999)
			iframeDom.insertOrReplaceCss(block_uid,block.css);
			iframeDom.insertOrReplaceJs(block_uid,block.js);
			iframeDom.dragElm.scrollIntoView({behavior:'smooth'});
			updateBlockList();
			// setTimeout(()=>{
			//   window.frameBus.mouseUpIframe(block_uid);
			// },1000);

		},
		mobileOpenAsideRight(){
			if(!isMobile()) return;
			this.mobileAsideRightActive = true;
		},
		mobileToggleAsideRight(){
			this.mobileAsideRightActive = !this.mobileAsideRightActive
		},
		mobileCloseAsideRight(){
			this.mobileAsideRightActive = false;
		},

		openDropdown(dropdown_id){
			this.dropdownActive = dropdown_id;
		},
		isOpenDropdown(dropdown_id){
			return this.dropdownActive == dropdown_id;
		},
		closeDropdown(){
			this.dropdownActive = '';
		},
		deleteMyBlock(block_id){
			if(!confirm('Confirm?')) return;
			axios({
				method: 'delete',
				url: '/api/block/'+block_id,
			}).then(()=>{
				this.$store.dispatch('getBlocks');
			});
		},

		getPage(){
			//get page
			return axios({
				url: '/api/project/'+this.id+'/page/'+this.page_id,
			}).then((res) => {
				if(!res.data.meta || Array.isArray(res.data.meta)) res.data.meta = {};
				this.page = res.data;
				var project_id = this.id;
				if(!this.$store.getters.project.id){
					this.$store.dispatch('getProject',project_id);
				}

				if(this.page.table_id){
					axios({
						url: '/api/data/'+this.page.table_id,
					}).then((res) => {
						this.posts = res.data.posts;
						this.selectPost(this.posts[0].id);
					});
					axios({
						url: '/api/tables/'+this.page.table_id,
					}).then((res) => {
						this.table = res.data
					});

				}

			}).catch(e=>{
				this.$router.replace('/');
			})
		},

		openModalDomain(){
			this.modalDomain = true;
		},
		toggleHighlight(block_uid,add){
			var block = iframeDom.document.querySelector('.block-'+block_uid);
			if(add){
				block.classList.add('hl');
			} else {
				block.classList.remove('hl');
			}
		},

		newPage(){
			if((this.edited || this.isSaving) && !confirm(this._lang('You have unsaved changes. Are you sure you want to leave?'))){
				return;
			}

			axios({
				method: 'post',
				url: '/api/pages',
				data: {
					name:this._lang('New page'),
					project_id:this.page.project_id,
				}
			}).then((res)=>{
				clearTimeout(window.saveTimer);
				this.$store.dispatch('getProject',this.id);
				this.$router.push('/project/'+this.page.project_id+'/'+res.data.id);
			});
		},
		togglePageDropdown(){
			this.pageDropdownOpened = !this.pageDropdownOpened;
		},
		toggleBlockDropdown(){
			this.blockDropdownOpened = !this.blockDropdownOpened;
			if(this.blockDropdownOpened){
				this.$nextTick(function(){
					var active = document.querySelector('.aside-right .dropdown-menu .active');
					if(active) active.scrollIntoView({block:'center'})
				});
			}
		},
		togglePublishDropdown(){
			this.publishDropdownOpened = !this.publishDropdownOpened;
		},
		mouseDownComponent(e,block){
			e.preventDefault();
			window.frameBus.handler = block;
		},

		saferEval(expr){
			return window.saferEval(expr,blockObj.data);
		},
		firstRenderIframe(){
			if(!iframeDom) return;
			if(!this.page.id) return;
			iframeDom.rootElm.innerHTML = this.page.output;

			this.pushHistory();

			updateBlockList({firstUpdate:true});
			if(this.project.fonts){
				var inject = this.project.fonts;
				if(this.project.meta.defaultFont){
					inject = '<style>body { font-family:"'+this.project.meta.defaultFont+'"; }</style> '+inject;
				}
				iframeDom.inject('project-fonts',inject);
			}
			if(this.project.header && this.page.slug!='/'){
				iframeDom.injectHeader(this.project.header);
			}
			if(this.project.footer && this.page.slug!='/'){
				iframeDom.injectFooter(this.project.footer);
			}

			if(this.selectedPost) this.selectPost(this.selectedPost);

		},
		/*
		insertComponent:function(block,uid){

			if(block) {


				//copy object without object reference //FIXME converting to json is ugly
				var newBlock = clone(block);
				newBlock.block_id = newBlock.id;
				newBlock.id = null;

				newBlock.uid = uid;
				newBlock.order = this.blocks.length;

				this.blocks.push(newBlock);
				this.selectedComponent = uid;
				this.toggleTabAsideRight('block');
				this.loadBlock(newBlock);
			};
		},
		*/
		editComponent:function(block){
			this.mobileOpenAsideRight();
			this.selectedComponent = block.uid;
			this.blockDropdownOpened = false;
			this.toggleTabAsideRight('block');
			this.loadBlock(block);
		},

		loadBlock:function(block){

			var blockIframe = iframeDom.getBlockObj(block.uid);
			block.template = blockIframe.template;
			block.css = blockIframe.css;
			block.js = blockIframe.js;
			block.name = blockIframe.name;

			this.block = block;

			blockObj.id = block.id;
			blockObj.block_id = block.block_id;
			blockObj.uid = block.uid;
			blockObj.order = block.order;
			blockObj.name = block.name;
			blockObj.template = block.template;
			blockObj.css = block.css;
			blockObj.js = block.js;
			blockObj.model = {}
			blockObj.data = {}
			blockObj.context = null;

			blockObj.context = findContext(blockObj.uid);

			parseBlockSource();
		},


		editCode(){
			this.modalEdit = true;

			if(this.isAdmin){
				var category = this.$store.getters.allblocks.find(category=>{
					if(category.blocks.find(b=>b.name==this.block.name)) return category;
					return null;
				})
				if(category) {
					this.block.category_id = category.id
					var block = category.blocks.find(b=>b.name==this.block.name);
					if(block){
						this.block.block_id = block.id
					}
				}
			}

			this.$nextTick(()=>{
				var textareaTemplate = document.querySelector('.block-template')
				textareaTemplate.value = blockObj.template;
				window.editorTemplate = CodeMirror.fromTextArea(textareaTemplate, {
					tabSize:2,
					mode: "xml",
					matchBrackets: true,
					styleActiveLine: true,
					theme:'dracula',

				});

				var textareaCss = document.querySelector('.block-css');
				textareaCss.value = blockObj.css;
				window.editorCss = CodeMirror.fromTextArea(textareaCss, {
					tabSize:2,
					mode: "css",
					matchBrackets: true,
					styleActiveLine: true,
					theme:'dracula',
				});

				var textareaJs = document.querySelector('.block-js');
				textareaJs.value = blockObj.js;
				window.editorJs = CodeMirror.fromTextArea(textareaJs, {
					tabSize:2,
					mode: "javascript",
					matchBrackets: true,
					styleActiveLine: true,
					theme:'dracula',
				});

			})

		},
		updateCode(){

			try{

				var template = editorTemplate.getValue()
				var dom = htmlToDom(template);
				var model = looseJsonParse(dom.getAttribute('x-vars'));

			} catch(e){
				console.error(e);
				alert('x-vars error: '+e)

				return;
			}


			blockObj.template = editorTemplate.getValue();
			blockObj.css = editorCss.getValue();
			blockObj.js = editorJs.getValue();
			this.edited = true;



			parseBlockSource();
			updateIframe();
			updateBlockList()
			this.modalEdit = false;
		},
		saveMyBlock(){
			if(!this.block.name){
				alert(this._lang('Block Name is required'));
				return;
			}

			blockObj.template = editorTemplate.getValue();
			blockObj.css = editorCss.getValue();
			blockObj.js = editorJs.getValue();

			var newBlock = {
				id:this.block.myblock_id,
				name:this.block.name,
				css:blockObj.css,
				js:blockObj.js,
				template:blockObj.template,
			}

			axios({
				method: 'post',
				url: '/api/newMyBlock',
				data: newBlock
			}).then(()=>{
				this.$store.dispatch('getBlocks');
				alert(this._lang('saved!'));
				this.modalSaveBlock = false;
			}).catch(res=>{
				console.error(res);
			});

		},
		saveBlock(){
			if(!this.block.name){
				alert(this._lang('Block Name is required'));
				return;
			}

			if(!this.block.block_id){
				var existing = this.blockCategories.find(category => {
					if(!category.blocks) return false;
					return category.blocks.find(block => {
						return block.name.toLowerCase() == this.block.name.toLowerCase();
					})
				});

				if(existing){
					alert(this._lang('Block Name already exists'));
					return;
				}
			}


			blockObj.template = editorTemplate.getValue();
			blockObj.css = editorCss.getValue();
			blockObj.js = editorJs.getValue();

			var newBlock = {
				id:this.block.block_id,
				name:this.block.name,
				category_id:this.block.category_id,
				image:this.block.image,
				css:blockObj.css,
				js:blockObj.js,
				template:blockObj.template,
			}


			axios({
				method: 'post',
				url: '/api/newBlock',
				data: newBlock
			}).then(()=>{
				this.$store.dispatch('getBlocks');
				alert(this._lang('saved!'));
			}).catch(res=>{
				console.error(res);
			});

		},



		xInputChange(field,newval){
			setValue(field,newval);

			if(blockObj.context){
				renderCollection(blockObj.context);
			}

		},



		setEffect(){
			var dom = htmlToDom(blockObj.template);
			if(this.effect){
				dom.setAttribute('data-effect',this.effect);
			} else {
				dom.removeAttribute('data-effect');
			}
			blockObj.template = dom.outerHTML;
			updateIframe();
			this.edited =true;

			//update block list to show effect icon
			var block = this.blocks.find((item) => item.uid == this.selectedComponent);
			block.effect = this.effect;

		},

		openPreview(){
			window.open(this.tempurl);
		},
		pushHistory(){
			var output = this.getPageOutput();
			if (!this.historyDisabled && output !== this.history[this.historyCursor]) {
				this.historyCursor ++;
				this.history.splice(this.historyCursor, this.history.length - this.historyCursor, output);
			}
		},
		getPageOutput(){
			var output = iframeDom.rootElm.innerHTML;
			return output.replace(/<(\/?)font[\s\S]*?>/g,'') //bugfix browser garbage
		},
		rescheduleSave(){
			clearTimeout(window.saveTimer);
			if(this.autoSave) {
				window.saveTimer = setTimeout(()=>{
					this.savePage()
				},5000);
			}
		},
		savePage(){

			clearTimeout(window.saveTimer);
			console.log('saving page');

			this.pushHistory();

			this.page.slug = this.page.slug.replace(/(^\/|\/$)/g,'') || '/';
			var output = this.getPageOutput();
			if(output===null || output===undefined) return;
			var data = {
				name:this.page.name,
				slug:this.page.slug,
				description:this.page.description,
				image:this.page.image,
				meta:this.page.meta,
				output: output,
				blocks:[],//this.orderedBlocks,
			}
			this.lastSavedTime = 'Saving';
			this.edited = false;
			return axios({
				method: 'post',
				url: '/api/page/'+this.page_id,
				data: data
			}).then(()=>{
				this.lastSavedTime = new Date();
			}).catch(error=>{
				alert(this._lang('Error'));
				console.log('error',error);
			});

		},


		undo() {
			if (!this.canUndo) return;
			if(this.edited && this.historyCursor == this.history.length-1){
				var currentCursor = this.historyCursor;
				this.pushHistory();
				this.historyCursor = currentCursor;
				this.reloadPath(this.history[this.historyCursor]);
				this.edited = false;
				return;
			}

			if(this.historyCursor==0) return;

			this.historyDisabled = true;
			this.historyCursor --;
			this.reloadPath(this.history[this.historyCursor]);
			this.historyDisabled = false;
		},
		reloadPath(output){
			iframeDom.rootElm.innerHTML = output;
			this.edited = true;
			this.rescheduleSave();
			updateBlockList();
			this.selectedComponent = '';
			this.toggleTabAsideRight('page');
		},


		redo() {
			if (!this.canRedo) return;
			this.historyDisabled = true;
			this.historyCursor ++;
			this.reloadPath(this.history[this.historyCursor]);
			this.historyDisabled = false;
		},

		removeBlock(uid){
			if(!confirm(this._lang('Remove block?'))) return;

			if(blockObj.context){
				var context = blockObj.context;
			}

			iframeDom.removeBlock(uid);
			updateBlockList();
			this.selectedComponent = '';
			this.toggleTabAsideRight('page');
			this.edited =true;

			if(context){
				renderCollection(context);
			}
		},


		duplicateBlock(uid){
			var newuid = iframeDom.duplicateBlock(uid);
			if(blockObj.context){
				renderCollection(blockObj.context);
			}
			this.edited = true;
			updateBlockList();
			//this.selectedComponent = newuid;
		},

		toggleTabAsideRight(tab){
			//if(this.selectedComponent) this.selectedComponent = '';
			this.tabAsideRight = tab;
		},

		searchDBBlocks(){

			var tables = [];
			iframeDom.document.querySelectorAll('[x-vars*="dbtable"]').forEach(element=>{
				var xVars = looseJsonParse(element.getAttribute('x-vars')) || {};
				for(var field in xVars){
					if(xVars[field]['dbtable']){
						if(!tables.includes(xVars[field]['dbtable'])) tables.push(xVars[field]['dbtable']);
					}
				}
			});

			console.log('tables found', tables);

			tables.forEach(table=>{
				renderCollection(table);
			})

		},

		autoThumbnail(){

			var params = [];
			params.push('size='+this.screenshotSize);
			if(this.screenshotTrim) params.push('trim=1');

			var url = '/api/block-screenshot/'+this.block.block_id+'?'+params.join('&');

			axios.get(url).then((response)=> {
				this.block.image = response.data
			}).catch((error) =>  {
				console.error(error);
				if(error.response) alert(error.response.data);
			})
		},
	}

}
window.PageGlobals = function(){

	window.observer = new Observable();
	window.queue = new Queue();

	window.iframeDom = null;

	window.blockObj = {
		uid:'editor',
		name:'',
		template:'',
		css:'',
		js:'',
		model:{},
		data:{},
		dom:null,
		context:null,
	};


	window.updateIframe = function(){
		iframeDom.insertOrReplaceHtml(blockObj.uid, blockObj.template,blockObj.name);
		iframeDom.insertOrReplaceCss(blockObj.uid, blockObj.css);
		iframeDom.insertOrReplaceJs(blockObj.uid, blockObj.js);
	};



	window.addLoopItem = function (field){
		var lastItem = blockObj.data[field][blockObj.data[field].length-1];
		var newItem = clone(lastItem);
		blockObj.data[field].push(newItem);
		blockObj.template = renderTemplateLoopAdd(blockObj.template,field);

		updateIframe();
		frameBus.selectBlock(blockObj.uid); //get template from output

		updateBlockList();

	}
	window.removeLoopItem = function (field,index){
		//blockObj.data[field].splice(index,1);
		blockObj.template = renderTemplateLoopRemove(blockObj.template,field,index);
		updateIframe();
		frameBus.selectBlock(blockObj.uid); //get template from output

		updateBlockList();
		refreshVueData();
	}
	//setValues('banners',[{"id":1,"name":"primeira carta","created_at":"2020-07-06T03:09:44.000000Z","carta":"carta xyz","valor":"30.000"},{"id":2,"name":"segunda carta","created_at":"2020-07-06T03:10:06.000000Z","carta":"carta xyz2","valor":"45.000"}]);
	window.setValues = function(field,data){
		blockObj.data[field] = data;
		blockObj.template = renderTemplateLoopSet(blockObj.template,field,data);
		updateVueData();
		refreshVueData();

		updateIframe();
	}
	window.setValue = function (field,value){
		var match = null;
		//repeat fields
		if(match = field.match(/([a-z0-9-]+)\[(\d+)\]\.([a-z0-9-]+)/i)){
			var parentKey  = match[1];
			var index = match[2];
			var subfield = match[3];
			blockObj.data[parentKey][index][subfield] = value;
			blockObj.template = renderTemplateLoopUpdate(blockObj.template,parentKey,index,subfield,value);
		} else {
			blockObj.data[field] = value;

			blockObj.template = renderTemplateUpdate(blockObj.template,field,value);
			blockObj.css = renderCssUpdate(blockObj.css,field,value);
			blockObj.js = renderJsUpdate(blockObj.js,field,value);
		}

		updateVueData();

		updateIframe();
	}
}



</script>
